module.exports = __webpack_public_path__ + "static/media/bgsuns.cb75665a.PNG";